export default __webpack_public_path__ + "static/media/like.4414507d.svg";